export default __webpack_public_path__ + "static/media/complete.8b65bc34.mp4";